import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AboutSeafarerWelfare from "./WelfareTabs/AboutSeafarerWelfare";
import ObjectivesOfWelfareProgramme from "./WelfareTabs/ObjectivesOfWelfareProgramme";
import WelfareServices from "./WelfareTabs/WelfareServices";
import CrewComplaints from "./WelfareTabs/CrewComplaints";
import GBVOverviewTab from "./WelfareTabs/GBVOverviewTab";
import AboutGBV from "./WelfareTabs/AboutGBV";
import WellbeingCorner from "./WelfareTabs/WellbeingCorner";
import InformationCorner from "./WelfareTabs/InformationCorner";
import SeafarerStories from "./WelfareTabs/SeafarerStories";
import WelfareOverviewTab from "./WelfareTabs/OverviewTab";

const sectionComponents = {
  "About-Seafarer-Welfare": <AboutSeafarerWelfare />,
  "Objectives-Of-Welfare-Programme": <ObjectivesOfWelfareProgramme />,
  "Welfare-Services": <WelfareServices />,
  "Crew-Complaints": <CrewComplaints />,
  "GBVOverviewTab": <GBVOverviewTab />,
  "AboutGBV": <AboutGBV />,
  "Wellbeing-Corner": <WellbeingCorner />,
  "Information-Corner": <InformationCorner />,
  "Seafarer-Stories": <SeafarerStories />,
  "Welfare-OverviewTab": <WelfareOverviewTab />,
};

function WelfareTabs() {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const initialSection = queryParams.get("section") || "About-Seafarer-Welfare";

  const [currentSection, setCurrentSection] = useState(initialSection);

  const handleClick = (section) => {
    setCurrentSection(section);
    navigate(`/welfare?section=${section}`);
    const closeBtn = document.querySelector(".btn-cus");
    if (closeBtn) closeBtn.click();
  };
  useEffect(() => {
    const updatedSection = queryParams.get("section");
    setCurrentSection(updatedSection);
    const el = document.getElementById(currentSection);
    if (updatedSection && sectionComponents[updatedSection]) {
      if (el && queryParams.get("section") !== null) {
        const yOffset = -150;
        const y = el.getBoundingClientRect().top + window.scrollY + yOffset;
        setTimeout(() => {
          window.scrollTo({ top: y, behavior: "smooth" });
        }, 100);
      } else {
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }, 100);
      }
      const isOverviewTab = updatedSection.toLowerCase() === "OverviewTab" || updatedSection.toLowerCase() === "ObjectivesOfWelfareProgramme";
      const collapseEl = document.getElementById("collapseOne");
      if (collapseEl && !isOverviewTab && collapseEl.classList.contains("show")) {
        collapseEl.classList.remove("show");
      }
    } else {
      setCurrentSection("AboutSeafarerWelfare");
      const collapseEl = document.getElementById("collapseTwo");
      if (collapseEl) collapseEl.classList.remove("show");
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  }, [location.search, location]);

  return (
    <section className="ManagementTeam px-3 small-anchor" id="ManagementTeam">
      <div className="container max-1330 mx-auto">
        <div className="row g-3 g-sm-4 g-md-5">
          <div className="col-lg-3">
            <div className="position-stiicky top-150">
              <div className="d-lg-none text-end">
                <i
                  className="bi bi-list  border-0 ms-auto font-32"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasResponsive"
                  aria-controls="offcanvasResponsive"
                ></i>
              </div>
              <div
                className="offcanvas-lg offcanvas-end"
                tabIndex="-1"
                id="offcanvasResponsive"
                aria-labelledby="offcanvasResponsiveLabel"
              >
                <div className="offcanvas-header d-lg-none">
                  <h5 className="offcanvas-title" id="offcanvasResponsiveLabel">
                    Our Services
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-cus"
                    data-bs-dismiss="offcanvas"
                    data-bs-target="#offcanvasResponsive"
                    aria-label="Close"
                  ></button>
                </div>
                <div
                  className="accordion leftMenu px-3 px-lg-0 pb-3 pb-md-0 overflow-auto overflow-md-visible"
                  id="accordionExample"
                >
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className={`accordion-button ${currentSection?.toLowerCase() === "OverviewTab" || currentSection?.toLowerCase() === "Objectives-Of-Welfare-Programme" ? "" : "collapsed"}`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="false"
                        aria-controls="collapseOne"
                      >About seafarer welfare
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className={`accordion-collapse ${currentSection?.toLowerCase() === "OverviewTab" || currentSection?.toLowerCase() === "Objectives-Of-Welfare-Programme" ? "" : "collapse"}`}
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body p-0">
                        <ul>
                          <li>
                            <button
                              type="button"
                              className={
                                currentSection?.toLowerCase() === "OverviewTab" ? "active" : ""
                              }
                              onClick={() => handleClick("OverviewTab")}
                            >
                              OVERVIEW
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              className={
                                currentSection === "Objectives-Of-Welfare-Programme" ? "active" : ""
                              }
                              onClick={() => handleClick("Objectives-Of-Welfare-Programme")}
                            >Objectives of the seafarer welfare programme
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button

                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        className={`accordion-button noAfter  ${currentSection === "Welfare-Services" ? "collapsed gray-active" : "collapsed"}`}
                        onClick={() => handleClick("Welfare-Services")}
                      >Services
                      </button>
                    </h2>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button

                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        className={`accordion-button noAfter  ${currentSection === "Crew-Complaints" ? "collapsed gray-active" : "collapsed"}`}
                        onClick={() => handleClick("Crew-Complaints")}
                      >Crew complaints
                      </button>
                    </h2>
                  </div>



                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className={`accordion-button ${currentSection?.toLowerCase() === "GBVOverviewTab" || currentSection?.toLowerCase() === "AboutGBV" ? "" : "collapsed"}`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >GBV
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className={`accordion-collapse ${currentSection?.toLowerCase() === "GBVOverviewTab" || currentSection?.toLowerCase() === "AboutGBV" ? "" : "collapse"}`}
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body p-0">
                        <ul>
                          <li>
                            <button
                              type="button"
                              className={
                                currentSection?.toLowerCase() === "GBVOverviewTab" ? "active" : ""
                              }
                              onClick={() => handleClick("GBVOverviewTab")}
                            >
                              OVERVIEW
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              className={
                                currentSection === "AboutGBV" ? "active" : ""
                              }
                              onClick={() => handleClick("AboutGBV")}
                            >What do we know about GBV at sea
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>



                  {/* <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                           className={`accordion-button noAfter  ${currentSection === "Wellbeing-Corner" ? "collapsed gray-active" : "collapsed"}`}
                                onClick={() => handleClick("Wellbeing-Corner")}
                        >Wellbeing corner
                        </button>
                      </h2>                
                    </div> */}


                  {/* <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button

                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        className={`accordion-button noAfter  ${currentSection === "Information-Corner" ? "collapsed gray-active" : "collapsed"}`}
                        onClick={() => handleClick("Information-Corner")}
                      >Information corner
                      </button>
                    </h2>
                  </div> */}

                  {/* <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button

                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        className={`accordion-button noAfter  ${currentSection === "Seafarer-Stories" ? "collapsed gray-active" : "collapsed"}`}
                        onClick={() => handleClick("Seafarer-Stories")}
                      >Seafarer Stories
                      </button>
                    </h2>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-9 col-md-8">
            <div id={currentSection}>
              {sectionComponents[currentSection] || <AboutSeafarerWelfare />}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WelfareTabs;
